module.exports = __webpack_public_path__ + "img/logo.73ead0a6.svg";